import { trackEvent } from '@finn-no/pulse-sdk';

export const trackHotelFavoriteLink = () =>
    trackEvent({
        type: 'Click',
        intent: 'Open',
        name: `View my favorite hotels`,
        object: {
            // @ts-ignore id can only be string
            id: undefined,
            type: 'UIElement',
            elementType: 'Link',
        },
        target: {
            // @ts-ignore id can only be string
            id: undefined,
            type: 'Listing',
            name: 'Favorite results',
        },
        vertical: {
            name: 'travel',
            subVertical: 'hotel',
        },
    });
